import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { Checkbox } from '@hotelplan/components.common.checkbox';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import MapAlternativeHotelPinContent from 'components/domain/map/MapProductPin/MapAlternativeHotelPinContent';

const ShowNearByContainer = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    alignItems: 'center',
    px: 2,
    label: {
      margin: 0,
      color: 'textGray',
      fontWeight: 'bold',
    },
    '.pin': {
      ml: 10,
      height: '30px',
    },
  })
);

interface IPdpMapShowNearbyControlProps {
  value: boolean;
  onChange(next: boolean): void;
}

const PdpMapShowNearbyControl: React.FC<IPdpMapShowNearbyControlProps> = (
  props: IPdpMapShowNearbyControlProps
) => {
  const { value, onChange } = props;
  const [t] = useTranslation('pdp');

  return (
    <ShowNearByContainer>
      <Checkbox
        name="showNearby"
        value="showNearby"
        content={t('pdp:map.control.showNearby')}
        checked={value}
        onChange={() => onChange(!value)}
      />
      <div className="pin">
        <MapAlternativeHotelPinContent />
      </div>
    </ShowNearByContainer>
  );
};

export default PdpMapShowNearbyControl;
